import M$plugin$MaxExtZoom from './/facade/js/maxextzoom';
import M$control$MaxExtZoomControl from './/facade/js/maxextzoomcontrol';
import M$impl$control$MaxExtZoomControl from './/impl/ol/js/maxextzoomcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.MaxExtZoom = M$plugin$MaxExtZoom;
window.M.control.MaxExtZoomControl = M$control$MaxExtZoomControl;
window.M.impl.control.MaxExtZoomControl = M$impl$control$MaxExtZoomControl;
